import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  const userLoggedIn = useSelector(state => state.userState.userLoggedIn);

  if (!userLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.instanceOf(Object).isRequired,
  layout: PropTypes.instanceOf(Object).isRequired,
};

export default ProtectedRoute;
